export default {
  props: ['dark', 'light', 'size']
}
